import { Delegation } from "./delegation";
import { IDelegation, IDelegationData } from "./delegation.types";

export const mockDelegationData = (): IDelegationData[] => [
  {
    id: 33,
    codeSol: "16",
    idSmartcash: "016",
    description: "Tucumán",
    principalBol: true,
    active: true,
  },
  {
    id: 34,
    codeSol: "02",
    idSmartcash: "002",
    description: "Sur - San Jose",
    principalBol: true,
    active: true,
  },
];

export const mockDelegation = (data: IDelegationData[] = mockDelegationData()): IDelegation[] =>
  data.map((item) => new Delegation(item));
